export const MIN_PASSWORD_LENGTH = 6;
export const REGISTRATION_MAX_LENGTH = 255;
export const SOCIAL_AUTH_PROVIDERS = ['facebook', 'google', 'apple'];
export const DATE_STRING_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const MP_PASSWORD_REGEX = /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
export const COUNTRY_CODE_REGEX = /^[a-zA-Z]{2,3}$/;
export const PHONE_COUNTRY_CODE_REGEX = /^(\+)?\d{1,4}$/;
//# sourceMappingURL=constants.js.map